<template>
    <LoginContent>
        <div class="row justify-content-center">
            <div class="col-12 col-lg-8 col-xl-5">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content tw:rounded-3xl">
                        <div class="h1 mb-4 text-center text-uppercase">{{ $t('login.titulo') }}</div>
                        <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                        <form class="w-100" @submit.prevent="login">
                            <div class="form-group">
                                <label for="email">{{ $t('formularios.email_usuario') }}</label>
                                <input type="text" name="email" id="email" v-model="formData.email"/>
                            </div>
                            <div class="form-group">
                                <label for="password">{{ $t('formularios.password') }}</label>
                                <input type="password" name="password" id="password" v-model="formData.password"/>
                                <span class="error" v-if="mensaje">{{ mensaje }}</span>
                            </div>

                            <div class="form-group">
                                <FormCaptchaComponent
                                    ref="captcha"
                                    :siteKey="sitekey"
                                    @success="onCaptchaVerified"
                                    @expired="onCaptchaInvalid"
                                    @error="onCaptchaInvalid"
                                />
                            </div>

                            <div class="row justify-content-md-between">
                                <div class="col-12 col-lg-6">
                                    <button type="submit" class="button" name="button" :disabled="!canSubmit">{{ $t('login.enviar') }}</button>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <p class="forgot recupera_texto">
                                        <router-link
                                            :to="{ name: 'forgot-password' }"
                                            class="text-underline text-bold"
                                        >
                                            <small>{{ $t('login.recuperar') }}</small>
                                        </router-link>
                                    </p>
                                </div>
                            </div>

                            <div class="row justify-content-md-between">
                                <div class="col-12">
                                    <p class="forgot recupera_texto">
                                        <router-link
                                            :to="{ name: 'register' }"
                                            class="text-underline text-bold"
                                        >
                                            <small>{{ $t('login.registro') }}</small>
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </LoginContent>
</template>

<script setup>
    import { ref } from 'vue';
    import { useHead } from '@/composables/common/seo/useHead';
    import { useLogin } from '@/composables/auth/useLogin';
    import LoginContent from '@/components/frontend/components/LoginContent';
    import FormCaptchaComponent from '@/modules/ui/FormCaptchaComponent.vue';

    useHead('Iniciar sesión');

    const captcha = ref(null);

    const {
        formData,
        loading,
        mensaje,
        sitekey,
        footer,
        canSubmit,
        onCaptchaVerified,
        onCaptchaInvalid,
        submit
    } = useLogin();

    const login = () => {
        submit(captcha.value);
    };
</script>

<style scoped>
    .recupera_texto {
        text-align: right;
    }

    @media (max-width: 768px)  {
        .recupera_texto {
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 1em;
        }
    }
</style>
